import React from 'react';
import {
	UncontrolledButtonDropdown,
	DropdownMenu,
	DropdownItem,
	DropdownToggle,
	Col,
	CardText,
	UncontrolledTooltip,
} from 'reactstrap';
import './listagem.common.styles.css';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';

function ListagemActionsComponent({
	toggleModalEncaminhar,
	acessoPermitido,
	usuario,
	toggleModal,
	openModalEntrega,
	toggleModalImprimir,
	toggleModalEtiquetas,
	toggleModalObservacoes,
	toggleModalRequisicaoImuno,
	toggleModalRequisicaoCongelacao,
	toggleModalEmail,
	liberarLaudo,
	acessos,
	item,
	handleModalCID,
	handleModalCancelamento,
}) {
	const dispatch = useDispatch();

	function getTranslate(key) {
		const intl = useIntl();
		return intl.formatMessage({ id: key });
	}

	function toggleModalfaturamento(props) {
		dispatch(
			commonActions.atualizarLaudoSelecionado({
				laudo: props.laudo,
				prontuario: props.prontuario,
				exame: props.idExame,
			})
		);
		return dispatch(commonActions.mudarStatusModalFaturamento(true));
	}

	return (
		<UncontrolledButtonDropdown className="mv-listagem-actions-button">
			<DropdownToggle color="link">
				<i className="fas fa-ellipsis-v" />
			</DropdownToggle>
			<DropdownMenu>
				{acessoPermitido(usuario, acessos.RastrearLaudo) &&
					acessoPermitido(usuario, acessos.Rastreabilidade) && (
						<DropdownItem
							className="menu"
							onClick={() => handleModalCID(item.laudo)}
						>
							<Col sm="auto" className="icone-exame">
								<CardText className="icone-Morfologia">
									<svg
										id={`morfologia_${item.id}`}
										width="30"
										height="30"
										viewBox="0 0 30 30"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM11.4395 18.3262C12.0527 17.7988 12.3926 17.0762 12.459 16.1582H10.7012C10.6621 16.6777 10.5078 17.0625 10.2383 17.3125C9.97266 17.5586 9.56836 17.6816 9.02539 17.6816C8.42383 17.6816 7.98242 17.4688 7.70117 17.043C7.42383 16.6172 7.28516 15.9434 7.28516 15.0215V14.377C7.29297 13.4941 7.44141 12.8438 7.73047 12.4258C8.02344 12.0039 8.46289 11.793 9.04883 11.793C9.58789 11.793 9.98828 11.918 10.25 12.168C10.5156 12.4141 10.6699 12.8125 10.7129 13.3633H12.4707C12.377 12.4102 12.0293 11.6699 11.4277 11.1426C10.8262 10.6152 10.0332 10.3516 9.04883 10.3516C8.33789 10.3516 7.71289 10.5195 7.17383 10.8555C6.63867 11.1875 6.22656 11.666 5.9375 12.291C5.64844 12.916 5.50391 13.6387 5.50391 14.459V14.9805C5.50391 16.2656 5.81641 17.2773 6.44141 18.0156C7.07031 18.75 7.93164 19.1172 9.02539 19.1172C10.0254 19.1172 10.8301 18.8535 11.4395 18.3262ZM13.7246 19H15.4824V10.4688H13.7246V19ZM17.1172 10.4688V19H19.7598C20.5059 18.9961 21.1758 18.8242 21.7695 18.4844C22.3633 18.1445 22.8223 17.666 23.1465 17.0488C23.4746 16.4316 23.6387 15.7266 23.6387 14.9336V14.541C23.6387 13.748 23.4727 13.041 23.1406 12.4199C22.8086 11.7949 22.3457 11.3145 21.752 10.9785C21.1621 10.6387 20.4922 10.4688 19.7422 10.4688H17.1172ZM18.875 17.5879V11.8926H19.7422C20.4336 11.8926 20.959 12.1172 21.3184 12.5664C21.6777 13.0117 21.8574 13.668 21.8574 14.5352V14.9863C21.8496 15.8223 21.6641 16.4648 21.3008 16.9141C20.9375 17.3633 20.4121 17.5879 19.7246 17.5879H18.875Z"
											fill="#32323D"
										/>
									</svg>
								</CardText>
								<UncontrolledTooltip
									placement="top"
									target={`morfologia_${item.id}`}
								>
									{getTranslate('dashboards.examDetails.cid')}
								</UncontrolledTooltip>
							</Col>
						</DropdownItem>
					)}
				{acessoPermitido(usuario, acessos.RastrearLaudo) &&
					acessoPermitido(usuario, acessos.Rastreabilidade) && (
						<DropdownItem
							className="menu"
							onClick={() => toggleModalEncaminhar()}
						>
							<Col sm="auto" className="icone-exame">
								<CardText className="icone-Morfologia">
									<i
										id={`segunda_opiniao_${item.id}`}
										className="mv-basico-dados_solicitacao"
									/>
									{/* <img
										width="30"
										height="30"
										viewBox="0 0 30 30"
										fill="none"
										src="https://upload.wikimedia.org/wikipedia/commons/5/5a/Icon_2_green.svg"
									></img> */}
								</CardText>
								<UncontrolledTooltip
									placement="top"
									target={`segunda_opiniao_${item.id}`}
								>
									{getTranslate('dashboards.referral.referral')}
								</UncontrolledTooltip>
							</Col>
						</DropdownItem>
					)}

				{acessoPermitido(usuario, acessos.RastrearLaudo) &&
					acessoPermitido(usuario, acessos.Rastreabilidade) && (
						<DropdownItem
							className="menu"
							onClick={() =>
								toggleModal(
									'rastreabilidade',
									item.laudo,
									item.prontuario,
									item.idExame
								)
							}
						>
							<Col sm="auto" className="icone-exame">
								<CardText className="icone-Faturamento">
									<i
										id={`rastreabilidade_${item.id}`}
										className="mv-basico-estrategia"
									/>
								</CardText>
								<UncontrolledTooltip
									placement="top"
									target={`rastreabilidade_${item.id}`}
								>
									{getTranslate('dashboards.examDetails.traceability')}
								</UncontrolledTooltip>
							</Col>
						</DropdownItem>
					)}

				{acessoPermitido(usuario, acessos.RastrearLaudo) &&
					acessoPermitido(usuario, acessos.Faturar) &&
					item.dataLiberacao === '' && (
						<DropdownItem
							onClick={() =>
								toggleModalfaturamento({
									laudo: item.laudo,
									prontuario: item.prontuario,
									idExame: item.idExame,
								})
							}
						>
							<Col sm="auto" className="icone-exame">
								<CardText className="icone-Faturamento">
									<i
										id={`faturamentoItem_${item.id}`}
										className="mv-basico-faturamento"
									/>
								</CardText>
								<UncontrolledTooltip
									placement="top"
									target={`faturamentoItem_${item.id}`}
								>
									{getTranslate('dashboards.examDetails.invoicing')}
								</UncontrolledTooltip>
							</Col>
						</DropdownItem>
					)}

				{acessoPermitido(usuario, acessos.RastrearLaudo) &&
					acessoPermitido(usuario, acessos.EntregaResultadoExames) &&
					(item.isLiberadoTotal ||
						item.existeBlocoCriado ||
						item.existemLaminasCriadas) && (
						<DropdownItem
						onClick={() => {
							openModalEntrega(item);
						}}
					>
						<Col sm="auto" className="icone-exame" style={{marginLeft:'3px'}}>
							<CardText className="icone-entrega">
								<i
									className="fas fa-notes-medical"
									id={`entregaResultadoExame_${item.id}`}
								/>
							</CardText>
							<UncontrolledTooltip
								placement="top"
								target={`entregaResultadoExame_${item.id}`}
							>
								{getTranslate("dashboards.examDetails.resultDelivery")}
							</UncontrolledTooltip>
						</Col>
					</DropdownItem>
				)}

				{item.etapas.find(
					(et) =>
						et.etapa !== etapasEnum.MATERIAL &&
						et.status !== statusEtapasEnum.NAO_REALIZADO &&
						et.status !== statusEtapasEnum.NAO_APLICAVEL
				) && (
					<DropdownItem onClick={() => toggleModalImprimir(item)}>
						<Col sm="auto" className="icone-exame">
							<CardText className="icone-anuencia">
								<i className="mv-basico-imprimir" id={`imprimir${item.id}`} />
							</CardText>
							<UncontrolledTooltip
								placement="top"
								target={`imprimir${item.id}`}
							>
								{getTranslate('dashboards.examDetails.printStep')}
							</UncontrolledTooltip>
						</Col>
					</DropdownItem>
				)}
				{item.etapas.find(
					(et) =>
						et.etapa === etapasEnum.MATERIAL &&
						(et.status === statusEtapasEnum.REALIZADO ||
							et.status === statusEtapasEnum.PENDENTE)
				) && (
					<DropdownItem onClick={() => toggleModalEtiquetas(item)}>
						<Col sm="auto" className="icone-exame">
							<CardText className="icone-anuencia">
								<i
									className="mv-basico-codigo_barras"
									id={`etiquetas${item.id}`}
								/>
							</CardText>
							<UncontrolledTooltip
								placement="top"
								target={`etiquetas${item.id}`}
							>
								{getTranslate('dashboards.examDetails.printLabels')}
							</UncontrolledTooltip>
						</Col>
					</DropdownItem>
				)}

				<DropdownItem onClick={() => toggleModalObservacoes(item)}>
					<Col sm="auto" className="icone-exame">
						<CardText className="icone-Faturamento">
							<i
								id={`observacaoItem_${item.id}`}
								className="mv-basico-resumo"
							/>
						</CardText>
						<UncontrolledTooltip
							placement="top"
							target={`observacaoItem_${item.id}`}
						>
							{getTranslate('dashboards.examDetails.includeRemarks')}
						</UncontrolledTooltip>
					</Col>
				</DropdownItem>

				{item.etapas.find(
					(et) => et.etapa === 'CONCLUSAO' && et.status !== 'realizado'
				) &&
					item.etapas.find(
						(et) =>
							et.etapa === etapasEnum.MATERIAL &&
							et.status === statusEtapasEnum.REALIZADO
					) &&
					item.existeBlocoCriado && (
						<DropdownItem
							onClick={() => toggleModalRequisicaoImuno(item.laudo)}
						>
							<Col sm="auto" className="icone-exame">
								<CardText className="icone-imuno">
									<i
										id={`req-imuno-${item.id}`}
										className="fas fa-eye-dropper"
									/>
								</CardText>
								<UncontrolledTooltip
									placement="top"
									target={`req-imuno-${item.id}`}
								>
									{getTranslate('dashboards.examDetails.protocolRequirements')}
								</UncontrolledTooltip>
							</Col>
						</DropdownItem>
					)}

				{item.etapas.find(
					(et) =>
						et.etapa === etapasEnum.CONCLUSAO &&
						et.status !== statusEtapasEnum.REALIZADO
				) &&
					item.etapas.find(
						(et) =>
							et.etapa === etapasEnum.MATERIAL &&
							et.status === statusEtapasEnum.REALIZADO
					) &&
					item.etapas.find(
						(et) =>
							et.etapa === etapasEnum.CONGELACAO &&
							et.status !== statusEtapasEnum.REALIZADO &&
							et.status !== statusEtapasEnum.CONCLUIDO
					) && (
						<DropdownItem
							onClick={() => toggleModalRequisicaoCongelacao(item.laudo)}
						>
							<Col sm="auto" className="icone-exame">
								{acessoPermitido(
									usuario,
									acessos.AdicionarBlocoseLaminasCongelacao
								) && (
									<React.Fragment>
										<CardText className="icone-congelacao">
											<i
												id={`req-congelacao-${item.id}`}
												className="fas fa-igloo"
											/>
										</CardText>
										<UncontrolledTooltip
											placement="top"
											target={`req-congelacao-${item.id}`}
										>
											{getTranslate('dashboards.examDetails.freezingRequest')}
										</UncontrolledTooltip>
									</React.Fragment>
								)}
							</Col>
						</DropdownItem>
					)}

				{!item.isLiberadoTotal &&
					item.etapas.find(
						(et) =>
							et.etapa === etapasEnum.CONCLUSAO &&
							et.status === statusEtapasEnum.REALIZADO
					) && (
						<DropdownItem onClick={() => liberarLaudo(item)}>
							<Col sm="auto" className="icone-exame">
								{acessoPermitido(usuario, acessos.LiberarLaudoParaEntrega) && (
									<React.Fragment>
										<CardText className="icone-liberar">
											<i
												id={`liberacao-laudo-${item.id}`}
												className="mv-basico-selecionar_todos"
											/>
										</CardText>
										<UncontrolledTooltip
											placement="top"
											target={`liberacao-laudo-${item.id}`}
										>
											{getTranslate('dashboards.examDetails.releaseReport')}
										</UncontrolledTooltip>
									</React.Fragment>
								)}
							</Col>
						</DropdownItem>
					)}
				<DropdownItem
					className="menu"
					onClick={() => toggleModal('controle_bloco_lamina', item)}
				>
					<Col sm="auto" className="icone-exame">
						<CardText className="icone-Faturamento">
							<i
								id={`controle_bloco_lamina_${item.id}`}
								className="mv-basico-consulta"
							/>
						</CardText>
						<UncontrolledTooltip
							placement="top"
							target={`controle_bloco_lamina_${item.id}`}
						>
							{getTranslate('dashboards.examDetails.blockBladeControl')}
						</UncontrolledTooltip>
					</Col>
				</DropdownItem>
				{item.emailDisponivel && (
					<DropdownItem
						className="email"
						onClick={() => toggleModalEmail(item.laudo)}
					>
						<Col sm="auto" className="icone-email">
							<CardText className="icone-Faturamento">
								<i id={`email_${item.id}`} className="mv-basico-mensagem" />
							</CardText>
							<UncontrolledTooltip placement="top" target={`email_${item.id}`}>
								{getTranslate('dashboards.examDetails.sendEmail')}
							</UncontrolledTooltip>
						</Col>
					</DropdownItem>
				)}

				<DropdownItem
					className="cancelar-etapas"
					onClick={() => handleModalCancelamento(item.laudo)}
				>
					<Col sm="auto" className="icone-exame">
						<CardText className="icone-CancelarEtapa">
							<i id={`cancelar_${item.id}`} className="mv-basico-cancelar" />
						</CardText>
						<UncontrolledTooltip placement="top" target={`cancelar_${item.id}`}>
							{getTranslate('dashboards.examDetails.reopenSteps')}
						</UncontrolledTooltip>
					</Col>
				</DropdownItem>
			</DropdownMenu>
		</UncontrolledButtonDropdown>
	);
}

export default ListagemActionsComponent;



// WEBPACK FOOTER //
// ./src/pages/main/listagem/listagem.actions.component.jsx